<template>
  <div class="pc-channel-sidebar">
    <div class="pc-sidebar-title">
      {{ $t('Bao.deposit') }}
    </div>

    <div class="my-money my-wallet-frame-n">
      <div class="wallet-card">
        <div class="bank-card-s">
          <div
            v-for="payment in payments"
            :key="payment.payment_id"
            class="channel-wrapper-n"
          >
            <div
              class="channel-bank-card-n"
              :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
              @click.stop="$emit('select', payment)"
            >
              <!-- 推薦標籤 -->
              <div
                v-if="payment.label && payment.label.length > 0"
                class="recommended-tags-frame"
              >
                <div v-if="payment.label[0]" class="recommended-tags red-bg">
                  {{ payment.label[0] }}
                </div>
                <div v-if="payment.label[1]" class="recommended-tags">
                  {{ payment.label[1] }}
                </div>
              </div>

              <div class="bank-choice-text grid-container">
                <div class="icon-deposit">
                  <img :src="payment.image" alt="">
                </div>
                <div class="channel-describe-frame">
                  <p class="channel-name-n">
                    {{ payment.name }}
                  </p>
                  <p
                    v-show="payment.code !== 'CcPayment' && payment.code !== 'AmoPay'"
                    class="describe-n"
                  >
                    {{ $t('Bao.min_to_max') }}:
                    <span class="secondary">
                      {{ parseInt(payment.amount_limit_front.min) }}-{{ parseInt(payment.amount_limit_front.max) }}
                    </span>
                  </p>
                </div>
              </div>

              <p class="fs-10px text-align-L flex-fill announcement">
                {{ payment.announcement }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositChannelSidebar',
  props: {
    /** 所有存款方式（已篩選、已排序的平鋪清單） */
    payments: {
      type: Array,
      default: () => []
    },
    /** 目前選中的渠道物件 */
    selectedPayment: {
      type: Object,
      default: null
    }
  },
  methods: {
    isSelectedPayment(payment) {
      return this.selectedPayment && this.selectedPayment.payment_id === payment.payment_id
    }
  }
}
</script>
